import { useEffect } from 'react';
import {
  Navigate,
  NavigateOptions,
  useNavigate,
  useParams,
} from 'react-router-dom';
import { selectActingUser } from 'redux/slices/actingUserSlice';
import {
  selectSelectedTeamMemberId,
  selectTeamMember,
} from 'redux/slices/selectedMemberSlice';
import { useAppDispatch, useAppSelector } from 'redux/store-hooks';
import DocketPage from '../../../docket/DocketPage';
import { Routes, SyncHook } from '../route-types';

export const DOCKET_PREFIX_PATH = '/docket';

const routes: Routes = [
  {
    path: '/',
    element: <Navigate to="/docket" />,
  },
  {
    path: '/docket',
    element: <DocketPage />,
  },
  {
    path: '/docket/guide/:guideId',
    element: <DocketPage />,
  },
];

const useSyncHook: SyncHook = () => {
  const { guideId: routeGuideId } = useParams();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const reduxGuideId = useAppSelector(selectSelectedTeamMemberId);
  const actingUser = useAppSelector(selectActingUser);

  useEffect(() => {
    // Make sure there is a guideId in the route
    // If no guide in the route and there is in the redux, update the route to include a guideId
    if (!!routeGuideId) {
      navigate(`${DOCKET_PREFIX_PATH}/guide/${routeGuideId}`, {
        replace: true,
      });
    } else {
      if (actingUser) {
        navigate(`${DOCKET_PREFIX_PATH}/guide/${actingUser.id}`, {
          replace: true,
        });
      } else {
        navigate(`${DOCKET_PREFIX_PATH}`, {
          replace: true,
        });
      }
    }
    // Make sure the selected guide in redux matches the route guideId
    if (routeGuideId && routeGuideId !== reduxGuideId) {
      dispatch(selectTeamMember(routeGuideId));
    }
  }, [routeGuideId, reduxGuideId, actingUser, navigate, dispatch]);
};

const useNavigationHooks = () => {
  const { guideId: routeGuideId } = useParams();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  return {
    toDocket: (guideId?: string, options?: NavigateOptions) => {
      if (guideId && guideId !== 'none') {
        navigate(`${DOCKET_PREFIX_PATH}/guide/${guideId}`, options);
        dispatch(selectTeamMember(guideId));
      } else if (routeGuideId && routeGuideId !== 'none') {
        navigate(`${DOCKET_PREFIX_PATH}/guide/${routeGuideId}`, options);
        dispatch(selectTeamMember(routeGuideId));
      } else {
        navigate(DOCKET_PREFIX_PATH, options);
      }
    },
  };
};

export const docketRouteConfig = {
  routes,
  useSyncHook,
  useNavigationHooks,
};
